import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";
import SEOQuizContainer from "./SEOQuizContainer";
import SEOResults from "./SEOResults";

const SEOQuiz: React.FC = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    navigate("quiz");
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <UserInfoForm
            subtitle="Dominate Local Search Results"
            onSubmit={handleUserInfoSubmit}
          />
        }
      />
      <Route path="quiz" element={<SEOQuizContainer userInfo={userInfo} />} />
      <Route path="results" element={<SEOResults />} />
    </Routes>
  );
};

export default SEOQuiz;
